// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-cell-container-AXxRR {
  white-space: nowrap;
  padding: 0px 26px;
  font-size: 15px;
  border-bottom: 1px solid #ECECEC;
  cursor: default;
}

.base-cell-container-AXxRR:first-child {
  padding-left: 0px;
}

.base-cell-container-AXxRR:last-child {
  width: 100%;
  padding-right: 0px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/base-cell/base-cell.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".container {\n  white-space: nowrap;\n  padding: 0px 26px;\n  font-size: 15px;\n  border-bottom: 1px solid #ECECEC;\n  cursor: default;\n}\n\n.container:first-child {\n  padding-left: 0px;\n}\n\n.container:last-child {\n  width: 100%;\n  padding-right: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `base-cell-container-AXxRR`
};
export default ___CSS_LOADER_EXPORT___;
